import { render, staticRenderFns } from "./setGame10.vue?vue&type=template&id=e3b8c136&"
import script from "./setGame10.vue?vue&type=script&lang=js&"
export * from "./setGame10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports